<template>
  <v-app>
    <v-toolbar prominent app height="55" class="col-xs-12" style="padding:0px;">
      <v-layout row wrap>
        <v-flex xs12>
          <v-layout xs12>
            <img
              v-if="restLogo != ''"
              class="smallImgWidth"
              style="width: 50px;height: 50px; margin-left:0px;max-width:80px;"
              :src="restLogo"
            />
            <div class="col-xs-10 col-md-10" style="padding:0px;">
              <h3 style="margin:0px;margin-left:5px;margin-top:10px;">{{ $t('eOrderBackendLogin') }}</h3>
            </div>
            <v-spacer></v-spacer>

            <!-- change Lang -->
            <!-- <p style="font-size:12px;margin-left:15px;margin-bottom:10px;">{{$t('Language')}}</p> -->
            <v-menu left bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon style="font-size: 32px;">translate</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-tile v-for="l in langList" :key="l" @click="changeLocalLang(l)">
                  <v-list-tile-title>{{ l }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-toolbar>

    <v-container style="margin-top:55px;">
      <v-card>
        <v-card-title class="headline lighten-2">
          <h2 style="margin:0px;">{{ $t('eOrderBackendLogin') }}</h2>
        </v-card-title>
        <v-card-text style="padding:10px;">
          <v-container grid-list-md style="padding-top: 0px;padding-bottom: 0px;">
            <v-layout wrap>
              <v-flex v-if="globalMode == 'normal'" xs12>
                <h4 class="userProfileTxt">{{ $t('UserName') }} :</h4>
                <input
                  v-model="backendLoginUName"
                  class="form-control"
                  name="backendLoginUName"
                  required
                  type="text"
                  @input="backendLoginUName = $event.target.value"
                />
              </v-flex>
              <v-flex v-if="globalMode == 'lite'" xs12>
                <h4 class="userProfileTxt">{{ $t('Email') }} :</h4>
                <input
                  v-model="backendLoginUName"
                  class="form-control"
                  name="backendLoginUName"
                  required
                  type="email"
                  @input="backendLoginUName = $event.target.value"
                />
              </v-flex>
              <v-flex xs12>
                <h4 class="userProfileTxt">{{ $t('Password') }} :</h4>
                <input
                  v-model="backendLoginUPswd"
                  class="form-control"
                  required
                  type="password"
                  name="backendLoginUPswd"
                  @input="backendLoginUPswd = $event.target.value"
                />
              </v-flex>
            </v-layout>
          </v-container>

          <div style="text-align: center;">
            <span
              v-if="errorMsgWithTran != ''"
              style="font-size:20px;"
              class="txtClrRed"
            >{{$t('' + errorMsgWithTran + '') }}</span>
            <span v-if="errorMsg != ''" style="font-size:20px;" class="txtClrRed">{{errorMsg}}</span>
            <br />
            <v-btn
              color="primary"
              style="width:90%;height:45px;"
              @click="loginToBackend()"
            >{{ $t('Login') }}</v-btn>
            <br v-if="globalMode == 'lite'" />
            <v-btn
              v-if="globalMode == 'lite'"
              color="primary"
              flat
              style="width:90%;"
              @click="openResetPw()"
            >
              <h6 style="margin:0px;">{{ $t('ResetPwd') }}</h6>
            </v-btn>
            <br />
            <v-btn color="primary" flat style="width:90%;" @click="backToHomePage()">
              <h6 style="margin:0px;">{{ $t('BackHomePage') }}</h6>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-container>

    <v-layout class="text-xs-center">
      <v-dialog v-model="resetPwDialog" persistent width="400">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            primary-title
            style="color: white;"
          >{{$t('ResetPwd')}}</v-card-title>
          <v-card-text v-if="successResetPw == false">
            <h4 class="userProfileTxt">{{ $t('Email') }} :</h4>
            <input
              v-model="backendLoginRPw"
              class="form-control"
              name="backendLoginRPw"
              required
              type="email"
              @input="backendLoginRPw = $event.target.value"
            />
            <h4
              v-if="resetPwError!=''"
              style="padding-top:5px;"
              class="txtClrRed"
            >{{ resetPwError }}</h4>
          </v-card-text>
          <v-card-text v-if="successResetPw == true">
            <h4 class="userProfileTxt">{{ $t('successResetPwMsg') }}</h4>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="successResetPw == false"
              color="default"
              flat
              @click="resetPwDialog = false"
            >{{$t('Cancel')}}</v-btn>
            <v-btn
              v-if="successResetPw == false"
              color="primary"
              flat
              @click="resetPw()"
            >{{$t('Next')}}</v-btn>
            <v-btn
              v-if="successResetPw == true"
              color="primary"
              flat
              @click="resetPwDialog = false"
            >{{$t('Okay')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <VersionDialog v-if="versionError"></VersionDialog>
  </v-app>
</template>

<script>
// import $ from 'jquery'
import Vue from 'vue'
import i18n from './i18n'
import { translateErrorMsg } from './translateErrorMsg'
import JS from './JsonService'
import VersionDialog from '../src/VersionNotMatchDialog'
import globalVar from './GlobalVar.js'
//import i18n from './i18n'
export default {
  components: {
    VersionDialog
  },
  mixins: [translateErrorMsg],
  // eslint-disable-next-line vue/require-prop-types
  props: ['mchdCode'],
  data() {
    return {
      backendLoginUName: '',
      backendLoginUPswd: '',
      errorMsg: '',
      mchCode: '',
      errorMsgWithTran: '',
      restLogo: '',
      langList: ['English', '中文'],
      versionError: false,
      resetPwDialog: false,
      backendLoginRPw: '',
      resetPwError: '',
      successResetPw: false,
      globalMode: globalVar.mode
    }
  },
  created: function() {
    sessionStorage.setItem('paramMchdCode', this.mchdCode)
    sessionStorage.setItem('backEndAddOrd', false)
    sessionStorage.setItem('backEndAddOrdKtnId', 0)
    sessionStorage.removeItem('sltTaskTitle')
    sessionStorage.removeItem('sltFilterStallName')
    sessionStorage.setItem(
      'isSearched',
      JSON.stringify({
        search: false
      })
    )
    sessionStorage.setItem(
      'isLoginedBackEnd',
      JSON.stringify({
        backEnd: false
      })
    )

    if (sessionStorage.getItem('fromRegister')) {
      var data = JSON.parse(sessionStorage.getItem('fromRegister'))
      this.mchCode = data.mchCode
      this.backendLoginUName = data.name
      this.backendLoginUPswd = data.pwd
      this.loginToBackend()
    } else {
      this.getInit()
    }
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    changeLocalLang(l) {
      var lTxt
      if (l == '中文') {
        lTxt = 'zh-chs'
      } else {
        lTxt = 'en-us'
      }

      //console.log(lTxt)
      //console.log($cookies.get('lang'))

      if (lTxt != Vue.$cookies.get('lang')) {
        console.log(lTxt)
        Vue.$cookies.set('lang', lTxt)
        i18n.locale = lTxt
      }
    },
    getInit() {
      this.versionError = false
      let initBackendPromise = new Promise(resolve => {
        if (sessionStorage.getItem('configData')) {
          resolve(sessionStorage.getItem('configData'))
        } else {
          fetch('/config.json')
            .then(res => res.json())
            .then(json => {
              var configData = JSON.stringify(json)
              sessionStorage.setItem('configData', configData)
              resolve(configData)
            })
        }
      })

      initBackendPromise.then(Msg => {
        if (JSON.parse(Msg).baseURLApi) {
          var domainName
          if (globalVar.mode == 'normal') {
            domainName = window.location.hostname
            //console.log('domainName:', domainName)

            // //For Testing
            if (globalVar.state == 'test') {
              if (
                domainName == 'localhost' ||
                domainName == '192.168.0.150' ||
                domainName == '192.168.0.193'
              ) {
                // domainName = 'eorder.postchat.us'
                //domainName = 'senjutei.mpos.us'
                //domainName = 'beizhan.mpos.us'
                domainName = 'demo.mpos.us'
                //domainName = 'test.mpos.us'
                //domainName = 'p9.mpos.us'
                //domainName = 'dtank.mpos.us'
              }
            }
          } else if (globalVar.mode == 'lite') {
            domainName = this.mchdCode
          }

          var version = sessionStorage.getItem('version')
          const url = 'Back/GetInitList'
          const parameter = {
            av: version,
            ko: domainName
          }

          JS.request(url, parameter)
            .then(response => {
              console.log(response.data)
              if (
                response.data == '@#=#@@=$#43@=$#Merchant Not Found@=$#0' ||
                response.data == 'Merchant Not Found'
              ) {
                //this.errorMsg = 'Merchant Code Not Found'
                this.errorMsgWithTran = translateErrorMsg.translateMsg(
                  response.data
                )
                this.versionError = false
              } else if (
                response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
                response.data == 'Version Not Match'
              ) {
                this.versionError = true
              } else {
                this.versionError = false
                if (response.data[0].kp) {
                  this.mchCode = response.data[0].kp
                  if (response.data[0].mv != '') {
                    this.restLogo = JS.checkImg(response.data[0].mv)
                    sessionStorage.setItem('restLogo', this.restLogo)
                  } else {
                    this.restLogo = ''
                    sessionStorage.setItem('restLogo', '')
                  }
                  sessionStorage.setItem('WAReplyMsg', response.data[0].rt)
                  sessionStorage.setItem(
                    'SchdTypeBtnName',
                    JSON.stringify({
                      DineIn: response.data[0].se,
                      TakeAway: response.data[0].sf,
                      Delivery: response.data[0].sg,
                      ScanOrder: response.data[0].si
                    })
                  )
                  sessionStorage.setItem('NoItemMsg', response.data[0].sh)
                  this.errorMsg = ''
                  this.errorMsgWithTran = ''
                } else {
                  this.errorMsg = response.data
                  this.errorMsgWithTran = ''
                }
              }
            })
            .catch(error => {
              //console.log(error)
              this.errorMsg = error
              this.errorMsgWithTran = ''
              this.versionError = false
            })
        }
      })
    },
    loginToBackend() {
      sessionStorage.setItem('fromRegister', '')
      this.errorMsg = ''
      this.errorMsgWithTran = ''

      if (this.mchCode == '' || this.mchCode == undefined) {
        //this.errorMsg = 'Merchant Code Not Found'
        this.errorMsgWithTran = translateErrorMsg.translateMsg(
          'Merchant Code Not Found'
        )
      } else {
        if (this.backendLoginUName.length < 1) {
          this.errorMsgWithTran = translateErrorMsg.translateMsg(
            'User Name Cannot be empty'
          )
        } else if (this.backendLoginUPswd.length < 1) {
          this.errorMsgWithTran = translateErrorMsg.translateMsg(
            'Password Cannot be empty'
          )
        } else {
          this.versionError = false
          this.errorMsgWithTran = ''
          var version = sessionStorage.getItem('version')
          const url = 'Back/Login'
          const para = {
            av: version,
            kp: this.mchCode,
            x: this.backendLoginUName,
            on: this.backendLoginUPswd
          }
          console.log(para)
          JS.request(url, para)
            .then(res => {
              console.log('res: ', res.data)
              if (
                res.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
                res.data == 'Version Not Match'
              ) {
                this.versionError = true
              }
              // if (
              //   res.data ==
              //     '@#=#@@=$#49@=$#Invalid Username Or Password@=$#0' ||
              //   res.data == 'Invalid Username Or Password'
              // ) {
              //   this.errorMsgWithTran = translateErrorMsg.translateMsg(
              //     'Invalid Username Or Password'
              //   )
              //   this.versionError = false
              // } else
              else {
                this.versionError = false
                this.errorMsgWithTran = ''
                if (res.data.ez) {
                  if (res.data.ez != undefined || res.data.ez != '') {
                    //console.log('successLogin')
                    this.errorMsg = ''
                    this.successLogin = true

                    sessionStorage.setItem('backendMchCode', this.mchCode)
                    sessionStorage.setItem(
                      'backendLoginedUserName',
                      this.backendLoginUName
                    )

                    sessionStorage.setItem(
                      'backendLoginInfo',
                      JSON.stringify({
                        UserId: res.data.m,
                        Name: res.data.ez,
                        Level: res.data.aq,
                        KtnID: res.data.rd,
                        KtnCode: res.data.qz,
                        KtnName: res.data.ra,
                        KtnOpen: res.data.rb,
                        KtnActive: res.data.rc,
                        ExpireBanner: res.data.fc
                      })
                    )

                    sessionStorage.setItem(
                      'isSearched',
                      JSON.stringify({
                        search: true
                      })
                    )

                    sessionStorage.setItem(
                      'isLoginedBackEnd',
                      JSON.stringify({
                        backEnd: true
                      })
                    )

                    if (globalVar.mode == 'normal') {
                      this.$router.replace('/Backend')
                    } else if (globalVar.mode == 'lite') {
                      var mchCd = sessionStorage.getItem('paramMchdCode')
                      this.$router.replace({
                        name: 'Backend',
                        params: { mchdCode: mchCd }
                      })
                    }
                  } else {
                    this.successLogin = false
                    this.errorMsg = res.data
                    //console.log('!successLogin')
                  }
                } else {
                  var errorMsgTxt = translateErrorMsg.translateMsg(res.data)
                  if (
                    errorMsgTxt == '' ||
                    errorMsgTxt == null ||
                    errorMsgTxt == undefined
                  ) {
                    this.errorMsg = res.data
                  } else {
                    this.errorMsgWithTran = errorMsgTxt
                  }
                  this.successLogin = false
                  //console.log('!successLogin')
                }
              }
            })
            .catch(err => {
              this.successLogin = false
              this.versionError = false
              console.log('!successLogin')
              console.log('err', err)
            })
        }
      }
    },
    backToHomePage() {
      if (globalVar.mode == 'normal') {
        this.$router.replace('/')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({ name: 'Search', params: { mchdCode: mchCd } })
      }
    },
    openResetPw() {
      this.successResetPw = false
      this.backendLoginRPw = ''
      this.resetPwError = ''
      this.resetPwDialog = true
    },
    resetPw() {
      if (this.backendLoginRPw == '' || this.backendLoginRPw == undefined) {
        this.resetPwError = 'Email Not Found'
      } else {
        this.versionError = false
        var version = sessionStorage.getItem('version')
        const url = 'Back/ResetPwd'
        const para = {
          av: version,
          kp: this.mchCode,
          x: this.backendLoginRPw
        }
        console.log(para)
        JS.request(url, para)
          .then(res => {
            console.log('res: ', res.data)
            this.successResetPw = false
            if (
              res.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
              res.data == 'Version Not Match'
            ) {
              this.versionError = true
            } else {
              this.versionError = false
              if (res.data.ht == 'Success') {
                this.resetPwError = ''
                this.successResetPw = true
              } else {
                this.resetPwError = res.data
              }
            }
          })
          .catch(err => {
            this.versionError = false
            this.resetPwError = err
            this.successResetPw = false
            console.log('err', err)
          })
      }
    }
  }
}
</script>

<style>
</style>
